export const MONTHLY_RATE_DIALOG_REMARK = 'MONTHLY_RATE_DIALOG_REMARK';

export const CAE_REMARK = 'CAE_REMARK';

export const CAE_CONFIGUREDCAR_REMARK = 'CAE_CONFIGUREDCAR_REMARK';

export const CAE_TECHDATA_REMARK = 'CAE_TECHDATA_REMARK';

export const STOCK_CAR_REMARK = 'STOCK_CAR_REMARK';

export const PRICE_DISCLAIMER_REMARK = 'PRICE_DISCLAIMER_REMARK';
